type AdminHeaderProps = {
  title: string;
  description: string;
  date?: Date;
};

function formatAdminDate(date: Date): string {
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function AdminHeader({
  title,
  description,
  date = new Date(),
}: AdminHeaderProps) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4 px-8 py-6">
      <div className="min-w-0 space-y-1">
        <h1 className="text-2xl font-bold tracking-tight text-white">
          {title}
        </h1>
        <p className="text-sm text-[#9194a1]">{description}</p>
      </div>
      <p className="shrink-0 text-sm font-medium text-[#9194a1]">
        {formatAdminDate(date)}
      </p>
    </header>
  );
}
